import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class productoSunatService {

    /******* QUERIES ******/

    async listarPorIdClaseSunat(idFamiliaSunat) {
        const response = await axios
            .get(`${ERP}administracion/producto-sunat/por-clase-sunat/${idFamiliaSunat}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new productoSunatService();